(() => {
  'use strict';
  const initialize = (root) => {
    if (root.dataset.jjInitialized === 'true') return;
    root.dataset.jjInitialized = 'true';
    const data = JSON.parse(root.querySelector('[data-jj-product-data]').textContent);
    const form = root.querySelector('.jj-product-form');
    const variantInput = form.querySelector('[data-jj-variant-select]');
    const quantity = form.querySelector('[name="quantity"]');
    const submit = form.querySelector('[data-jj-add]');
    const submitLabel = form.querySelector('[data-jj-add-label]');
    const message = form.querySelector('[data-jj-form-message]');
    const cartLink = form.querySelector('[data-jj-cart-link]');
    const stage = root.querySelector('[data-jj-gallery-current]');
    const galleryButtons = Array.from(root.querySelectorAll('[data-jj-gallery-button]'));
    const galleryDots = Array.from(root.querySelectorAll('[data-jj-gallery-dot]'));
    let galleryIndex = 0;
    let requestInFlight = false;
    const selectedVariant = () => data.variants.find((variant) => String(variant.id) === String(variantInput.value));
    const templateFor = (variant) => root.querySelector(`template[data-jj-variant-media="${variant.id}"]`);
    const lightbox = root.querySelector('[data-jj-lightbox]');
    const zoomContent = root.querySelector('[data-jj-zoom-content]');
    const zoomButton = root.querySelector('[data-jj-zoom]');
    let previousOverflow = null;
    const renderZoom = () => {
      if (!zoomContent) return;
      zoomContent.replaceChildren(...Array.from(stage.childNodes, node => node.cloneNode(true)));
      zoomContent.querySelectorAll('img').forEach(image => {
        image.loading = 'eager';
        image.sizes = image.hasAttribute('data-jj-cropped') ? '(max-width: 900px) 213.333vw, 2347px' : '(max-width: 900px) 100vw, 1100px';
      });
    };
    const closeZoom = () => { if (lightbox?.open) lightbox.close(); };
    if (lightbox && zoomButton && typeof lightbox.showModal === 'function') {
      zoomButton.hidden = false;
      zoomButton.addEventListener('click', () => {
        if (lightbox.open) return;
        renderZoom();
        previousOverflow = document.body.style.overflow;
        lightbox.showModal();
        document.body.style.overflow = 'hidden';
        root.querySelector('[data-jj-zoom-close]')?.focus();
      });
      root.querySelector('[data-jj-zoom-close]')?.addEventListener('click', closeZoom);
      lightbox.addEventListener('close', () => {
        if (previousOverflow !== null) document.body.style.overflow = previousOverflow;
        previousOverflow = null;
        zoomButton.focus({preventScroll: true});
      });
      lightbox.addEventListener('click', event => {
        if (event.target !== lightbox) return;
        const bounds = lightbox.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeZoom();
      });
      lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          selectImage(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }

    const setMessage = (text, error = false) => {
      message.textContent = text;
      message.hidden = !text;
      message.classList.toggle('is-error', error);
    };
    const selectImage = (index, announce = true) => {
      galleryIndex = (index + galleryButtons.length) % galleryButtons.length;
      const button = galleryButtons[galleryIndex];
      if (galleryIndex === 0) {
        const variant = selectedVariant();
        const template = variant && templateFor(variant);
        if (template && !stage.querySelector(`[data-variant-id="${variant.id}"]`)) stage.replaceChildren(template.content.cloneNode(true));
      } else {
        const image = document.createElement('img');
        image.className = 'jj-product-image';
        if (button.dataset.jjGallerySrcset) image.srcset = button.dataset.jjGallerySrcset;
        image.sizes = button.dataset.jjGallerySizes || '(max-width: 760px) 100vw, 60vw';
        image.src = button.dataset.jjGallerySrc;
        image.alt = button.dataset.jjGalleryAlt || data.title;
        image.decoding = 'async';
        image.width = Number(button.dataset.jjGalleryWidth) || 1600;
        image.height = Number(button.dataset.jjGalleryHeight) || 1300;
        stage.replaceChildren(image);
      }
      const mainImage = stage.querySelector('img');
      if (mainImage) { mainImage.loading = 'eager'; mainImage.fetchPriority = 'high'; }
      galleryButtons.forEach((entry, current) => entry.setAttribute('aria-pressed', String(current === galleryIndex)));
      galleryDots.forEach((entry, current) => entry.setAttribute('aria-pressed', String(current === galleryIndex)));
      const mediaNote = root.querySelector('[data-jj-media-note]');
      const note = galleryIndex === 0 ? stage.querySelector('[data-media-note]')?.dataset.mediaNote || '' : button.dataset.jjGalleryNote || '';
      mediaNote.textContent = note;
      mediaNote.hidden = !note;
      if (announce) root.querySelector('[data-jj-gallery-status]').textContent = `Image ${galleryIndex + 1} of ${galleryButtons.length}`;
      if (lightbox?.open) renderZoom();
    };
    galleryButtons.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
    galleryDots.forEach((button) => button.addEventListener('click', () => selectImage(Number(button.dataset.jjGalleryDot))));
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        selectImage(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let touchStart = null;
    stage.addEventListener('touchstart', (event) => {
      if (event.touches.length === 1) touchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};
    }, {passive: true});
    stage.addEventListener('touchend', (event) => {
      if (!touchStart || !event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - touchStart.x;
      const deltaY = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) selectImage(galleryIndex + (deltaX < 0 ? 1 : -1));
      touchStart = null;
    }, {passive: true});

    const updateVariant = (updateUrl = true) => {
      const variant = selectedVariant();
      if (!variant) return;
      root.querySelector('[data-jj-price]').innerHTML = variant.price;
      const compare = root.querySelector('[data-jj-compare]');
      compare.innerHTML = variant.compare;
      compare.hidden = !variant.onSale;
      root.querySelector('[data-jj-stock]').textContent = variant.available ? 'In stock' : 'Sold out';
      submit.disabled = !variant.available || requestInFlight;
      submitLabel.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      const note = root.querySelector('[data-jj-pack-note]');
      if (note) note.textContent = /only/i.test(variant.title) ? 'Refill heads only. A handle is not included.' : 'Includes 1 handle and the selected number of refill heads.';
      const sku = root.querySelector('[data-jj-sku]');
      sku.hidden = !variant.sku;
      sku.textContent = variant.sku ? `Product code: ${variant.sku}` : '';
      const template = templateFor(variant);
      if (template) {
        const marker = `[data-variant-id="${variant.id}"]`;
        const thumbnailTarget = root.querySelector('[data-jj-studio-thumbnail]');
        const detailTarget = root.querySelector('[data-jj-detail-media]');
        // Keep correctly sized server-rendered media; only rebuild after a real variant change.
        if (thumbnailTarget && !thumbnailTarget.querySelector(marker)) {
          const thumbnail = template.content.cloneNode(true);
          thumbnail.querySelectorAll('img').forEach(image => { image.sizes = image.hasAttribute('data-jj-cropped') ? '140px' : '65px'; image.loading = 'lazy'; image.fetchPriority = 'auto'; });
          thumbnailTarget.replaceChildren(thumbnail);
        }
        if (detailTarget && !detailTarget.querySelector(marker)) {
          const detailMedia = template.content.cloneNode(true);
          detailMedia.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.fetchPriority = 'auto'; });
          detailTarget.replaceChildren(detailMedia);
        }
      }
      selectImage(0, updateUrl);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        setMessage('');
        cartLink.hidden = true;
      }
      root.dispatchEvent(new CustomEvent('sopami:variantchange', {bubbles: true, detail: {productId: data.id, variant}}));
    };
    variantInput.addEventListener('change', () => updateVariant());
    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id && data.variants.some((variant) => String(variant.id) === id)) { variantInput.value = id; updateVariant(false); }
    });
    form.querySelectorAll('[data-jj-quantity]').forEach((button) => button.addEventListener('click', () => {
      const current = Number.parseInt(quantity.value, 10) || 1;
      quantity.value = Math.max(1, current + Number(button.dataset.jjQuantity));
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    quantity.addEventListener('change', () => {
      const entered = Number(quantity.value);
      if (!Number.isSafeInteger(entered) || entered < 1) quantity.value = 1;
    });
    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      if (requestInFlight) return;
      const variant = selectedVariant();
      if (!variant?.available) { setMessage('This option is sold out. Please choose another option.', true); return; }
      if (!form.reportValidity()) return;
      requestInFlight = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = 'ADDING…';
      setMessage('');
      cartLink.hidden = true;
      try {
        const payload = new FormData(form);
        const response = await fetch(root.dataset.cartAddUrl, {method: 'POST', body: payload, credentials: 'same-origin', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'The item could not be added. Please try again.');
        let cart = result;
        try {
          const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
          if (cartResponse.ok) cart = await cartResponse.json();
        } catch (_) { /* The successful add remains successful if the cart read fails. */ }
        setMessage('Added to your bag.');
        cartLink.hidden = false;
        document.dispatchEvent(new CustomEvent('sopami:cartchange', {detail: cart}));
      } catch (error) {
        const uncertain = error instanceof TypeError || error instanceof SyntaxError;
        setMessage(uncertain ? 'We could not confirm the result. Please check your bag before trying again.' : error.message || 'The item could not be added. Please try again.', true);
        if (uncertain) cartLink.hidden = false;
      } finally {
        requestInFlight = false;
        submit.removeAttribute('aria-busy');
        const current = selectedVariant();
        submit.disabled = !current?.available;
        submitLabel.textContent = current?.available ? 'ADD TO BAG' : 'SOLD OUT';
      }
    });

    const saveButton = root.querySelector('[data-jj-product-save]');
    const wishlistKey = 'sopami:wishlist';
    const readWishlist = () => {
      try { const saved = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); return Array.isArray(saved) ? saved : []; } catch (_) { return []; }
    };
    const renderSaved = () => {
      const saved = readWishlist().includes(root.dataset.productHandle);
      saveButton.setAttribute('aria-pressed', String(saved));
      saveButton.setAttribute('aria-label', `${saved ? 'Remove saved' : 'Save'} ${data.title}`);
      saveButton.querySelector('.jj-product-save-label').textContent = saved ? 'Saved' : 'Save';
    };
    saveButton.addEventListener('click', () => {
      try {
        const saved = readWishlist();
        const handle = root.dataset.productHandle;
        const next = saved.includes(handle) ? saved.filter((item) => item !== handle) : [...saved, handle];
        localStorage.setItem(wishlistKey, JSON.stringify(next));
        renderSaved();
        document.dispatchEvent(new CustomEvent('sopami:wishlistchange', {detail: next}));
      } catch (_) { setMessage('Your browser could not save this item.'); }
    });
    window.addEventListener('storage', renderSaved);
    document.addEventListener('sopami:wishlistchange', renderSaved);
    renderSaved();
    updateVariant(false);
  };
  const mount = (scope = document) => {
    if (scope.matches?.('[data-jj-product]')) initialize(scope);
    scope.querySelectorAll('[data-jj-product]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount()); else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
